// --------------------------------------- Project List

export const ProjectList = [
  {
    img: "https://i.postimg.cc/3xSWgpYZ/Screenshot-2025-11-04-210644.png",
    title: "Bubble Math Game",
    description: `Developed a Simple Bubble game there after every click your score adds on by 10.`,
    tech_stack: "HTML, CSS, Javascript ",
    github_url: "https://github.com/Sen-Pai-11/Bubble-Game",
    demo_url: "https://sen-pai-11.github.io/Bubble-Game/",
  },
  {
    img: "https://i.postimg.cc/BvWD8k3z/Screenshot-2025-11-04-225708.png",
    title: "Simple Calculator",
    description: `This is a simple calculator build using ReactJS. It can perform basic arithmetic operations like addition, subtraction, multiplication, and division.`,
    tech_stack: "HTML, CSS, Javascript, ES6, ReactJS",
    github_url: "https://github.com/Sen-Pai-11/Simple-Calculator",
    demo_url: "https://sen-pai-11.github.io/Simple-Calculator/",
  },
  {
    img: "https://i.postimg.cc/RhNbbVRy/Screenshot-2025-11-05-135944.png",
    title: "basic Personal Portfolio",
    description:
      "My passion lies in creating elegantly simple designs and writing clean code. I find immense joy in the work I do and take pride in my abilities.",
    tech_stack: "HTML, CSS, Javascript",
    github_url: "https://github.com/Sen-Pai-11/Basic-portfolio",
    demo_url: "https://sen-pai-11.github.io/Basic-portfolio/",
  },

  {
    // img: "https://i.ibb.co/JKLcM1g/hand-Sanitizer.png",
    title: "NetflixGPT - major Project",
    description:
      "Please be Patient, Working on it, Great things take time :)",
    tech_stack: "HTML, CSS, Javascript, ReactJS.",
    // github_url: "https://github.com/samarjeetpatankar/Hand-Sanitizer-website",
    // demo_url: "https://haan-website-clone-pt12.netlify.app/",
  },
  // {
  //   title: "please wait, Good things take time"
  // }
];

// --------------------------------------- Skills-------------------------//

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    name: "Redux",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
    name: "MongoDB",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png",
    name: "Express",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "TypeScript",
  },
  // {
  //   img: "https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg",
  //   name: "Chakra Ui",
  // },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    name: "Postman",
  },
];
